import { BlockOverrides } from 'baseui/block';

export const BLOCK: BlockOverrides = {
  Block: {
    style: {
      marginTop: '16px',
      marginLeft: '24px',
      marginRight: '24px',
      width: 'calc(100% - 48px)',
      position: 'absolute',
    },
  },
};
